var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAuditTrail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chart/List") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audit-trail_empty",
    transform: "translate(-698.000000, -374.000000)",
    fill: "#054169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart/List",
    transform: "translate(688.000000, 363.871901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,35.8545455 L10.6666667,39.7333333 C10.6666667,40.8969697 11.4424242,41.6727273 12.6060606,41.6727273 L35.8787879,41.6727273 C37.0424242,41.6727273 37.8181818,40.8969697 37.8181818,39.7333333 L37.8181818,35.8545455 C37.8181818,34.6909091 37.0424242,33.9151515 35.8787879,33.9151515 L12.6060606,33.9151515 C11.4424242,33.9151515 10.6666667,34.6909091 10.6666667,35.8545455 L10.6666667,35.8545455 Z M10.6666667,12.6060606 L10.6666667,16.4848485 C10.6666667,17.6484848 11.4424242,18.4242424 12.6060606,18.4242424 L28.1212121,18.4242424 C29.2848485,18.4242424 30.0606061,17.6484848 30.0606061,16.4848485 L30.0606061,12.6060606 C30.0606061,11.4424242 29.2848485,10.6666667 28.1212121,10.6666667 L12.6060606,10.6666667 C11.4424242,10.6666667 10.6666667,11.4424242 10.6666667,12.6060606 L10.6666667,12.6060606 Z M10.6666667,24.230303 L10.6666667,28.1090909 C10.6666667,29.2727273 11.4424242,30.0484848 12.6060606,30.0484848 L43.6363636,30.0484848 C44.8,30.0484848 45.5757576,29.2727273 45.5757576,28.1090909 L45.5757576,24.230303 C45.5757576,23.0666667 44.8,22.2909091 43.6363636,22.2909091 L12.6060606,22.2909091 C11.4424242,22.2909091 10.6666667,23.0666667 10.6666667,24.230303 L10.6666667,24.230303 Z M10.6666667,47.4787879 L10.6666667,51.3575758 C10.6666667,52.5212121 11.4424242,53.2969697 12.6060606,53.2969697 L51.3939394,53.2969697 C52.5575758,53.2969697 53.3333333,52.5212121 53.3333333,51.3575758 L53.3333333,47.4787879 C53.3333333,46.3151515 52.5575758,45.5393939 51.3939394,45.5393939 L12.6060606,45.5393939 C11.4424242,45.5393939 10.6666667,46.3151515 10.6666667,47.4787879 L10.6666667,47.4787879 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAuditTrail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Audit-trail.db0c495f1d6f5b65b14afd1b5ea18b62.svg";